import { Dialog, DialogSurface, DialogBody, DialogContent, makeStyles } from "@fluentui/react-components";
import { ReactComponent as SahlLogo } from "../../assets/images/Sahl-Logo.svg";
import { Button, FontColor, Label, TextStyle } from "@lannister/duplo";
import CopyToClipboard from "../../common/copyToClipboard";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        gap: "16px",
    },
    codeWrapper: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        width: "50%",
        alignItems: "space-between",
        border: "1px solid #E6E8FA",
        borderRadius: "8px",
        padding: "8px",
        minHeight: "40px",
    }
});

const PayByCode = ({ code }) => {
    const styles = useStyles();

    const goToApp = () => {
        window.open("https://sahlpayapp.page.link/bdj7", "_self")
    }

    return (
        <Dialog open={true}>
            <DialogSurface>
                <DialogBody>
                    <DialogContent>
                        <div className={styles.container}>
                            <SahlLogo />
                            <div className={styles.codeWrapper}>
                                <Label labelText={code} textStyle={TextStyle.Heading6Semibold} />
                                <CopyToClipboard textToCopy={code} />
                            </div>
                            <Label labelText="This code is valid for 2 days" textStyle={TextStyle.Heading5Regular} />
                            <Label wrap={true} textColor={FontColor.Secondary} labelText="You can pay using this reference code at" textStyle={TextStyle.Heading6Regular} />
                            <Label wrap={true} textColor={FontColor.Secondary} labelText="Sahl App, Opay, Gidea, DAMEN, AMAN" textStyle={TextStyle.Heading6Semibold} />
                            <Button onClick={goToApp}>Pay Now</Button>
                        </div>
                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}

export default PayByCode;